import React from "react";
import "./Menu.css";

const Menu = () => {
  const logo = "../../public/logo192.png";
  return (
    <div className="Menu">
      <div className="Menu-logo" onClick={() => window.scrollTo(0, 0)}></div>
      <nav>
        <ul>
          <li>
            <a href="#about">Notre Agence</a>
          </li>
          <li>
            <a href="#services">Nos Services</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Menu;
